import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import MaterialTypography from "../../../components/MaterialTypography";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Grid,
  Stack,
  Button,
  TextField,
} from "@mui/material";
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BASEURL from "../../Utils/Baseurl";
import moment from "moment-timezone";
import Swal from "sweetalert2";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import { useUserDetails } from "../../../context/auth";
function WFHApproval() {
  const [employeeData, setemployeeData] = useState([]);
  const { Manager, setManager, HRRole, AccessData } = useUserDetails();
  const [display, setdisplay] = useState(false);
  const navigate = useNavigate();
  const [ID, setID] = useState("");
  const locatdatas = JSON.parse(sessionStorage.getItem("user"));

  let Roledata = JSON.parse(sessionStorage.getItem("WFHApp"));

  console.log("Roledata:", Roledata);
  const [Alldata, setAlldata] = useState("");
  console.log("Alldata:", Alldata);

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setID(id);
    if (id) {
      getInitData(id);
    }
  }, []);

  const getInitData = async (id) => {
    const query = ` query WfhRequestGetById($id: String!){ 

  getWfhById(id: $id){ 

    data{ 

      id 

      user{ 

        id 

        firstName 

        lastName 

        email 

        empid 

      } 

      leaveType{ 

        id 

        name 

      } 

      requestedDate 

      startDate 

      endDate 

      reason 

      totalDays 

      task 

      teamleaderId 

      teamApproval 

      hrApproval 

      status 

      approvalStatus{ 

        id 

        status 

        approver{ 

          id 

          firstName 

          lastName 

          email 

        } 

      } 

    } 

    success 

    error 

    message 

  } 

}  `;
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const weekoffRowdata = response.data.data.getWfhById?.data[0];
      console.log("weekoffRowdata:", weekoffRowdata);

      setemployeeData(weekoffRowdata);
      setAlldata(weekoffRowdata);

      if (
        (Roledata == "Hr" || Roledata == "HR") &&
        weekoffRowdata.teamApproval === "approved" &&
        weekoffRowdata.hrApproval === "pending"
      ) {
        setdisplay(true);
      }
    } catch (error) {
      console.error("ResponseError:", error);
    }
  };

  const handleAddLeave = (statusdata) => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: `Are you sure you want to ${
        statusdata == "approved"
          ? "Approve"
          : statusdata == "rejected"
          ? "Reject"
          : ""
      } the leave?`,
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        ApproveSubmit(statusdata);
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const ApproveSubmit = async (statusdata) => {
    let query;
    let variables;
    if (employeeData?.approvalStatus !== null) {
      query = `
        mutation Work_From_Home_Manager_Approval($id:String, $approver_id: ID!, $status: String!, $task: String, $screen_name: String!){  
 
 
WfhManagerApproval(id: $id, approverId: $approver_id, status: $status, task: $task screenName: $screen_name) { 			wfhApprovalManager {
 
id  
requestedDate  
 
                startDate  
 
                endDate  
 
                reason  
 
                totalDays  
 
                task  
 
                teamApproval  
 
                hrApproval  
 
                lastUpdate  
 
                user {  
 
                  id  
 
                  firstName  
 
                }  
                approvalStatus{
                  id
                  approver{
                    id
                    firstName
                    lastName
                  }
                  status
                }
 
 
}  
 
message  
 
success  
 
error  
 
}
 
} 
       `;

      variables = {
        id: ID,
        status: statusdata,
        approver_id: locatdatas?.id,
        screen_name: "Work From Home Approval",
        task: "task",
      };
    } else {
      query = `
      mutation Work_From_Home_hr_Approval($id:String!, $status: String!){  
 
 
WfhApprovalHR(id: $id, status: $status,) { 			wfhApprovalHR {
 
id  
 
}  
 
message  
 
success  
 
error  
 
}
 
}
    `;

      variables = {
        id: +ID,
        status: statusdata,
      };
    }

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: variables,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      console.log("responsemanager:", response.data);

      // console.log(
      //   "Response:",
      //   response.data.data.regularizationApproval.regularizationApprovalHR
      // );
      if (response.data.data?.WfhApprovalHR?.wfhApprovalHR) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: `${
            statusdata.charAt(0).toUpperCase() + statusdata.slice(1)
          } successfully!`,
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/wfh-management");
      } else if (response.data.data?.WfhManagerApproval?.wfhApprovalManager) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: `${
            statusdata.charAt(0).toUpperCase() + statusdata.slice(1)
          } successfully!`,
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/wfh-management");
      }
      // Handle success (e.g., show a success message or navigate)
    } catch (error) {
      console.error("Error in ApproveSubmit:", error);
      // Handle error (e.g., show a user-friendly error message)
    }
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB"); // This will return 'dd/mm/yyyy' format
  }

  const handleclose = () => {
    navigate("/wfh-management");
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card sx={{ padding: 1, boxShadow: 4, borderRadius: 2 }}>
        {/* Card Title */}
        <CardHeader
          title={
            <Typography
              variant="h5"
              fontWeight="bold"
              textAlign="center"
              gutterBottom
            >
              WFH Details
            </Typography>
          }
        />

        {/* Leave Details Content */}
        <CardContent>
          <Grid container spacing={1} marginLeft={"4%"}>
            {/* Left Column */}
            <Grid item xs={12} sm={6}>
              <Stack spacing={2}>
                <Typography variant="h6">
                  <strong>User Name:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.user?.firstName?.toUpperCase() + " " + employeeData?.user?.lastName?.toUpperCase()}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Start Date:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.startDate}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>End Date:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.endDate}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Total Days:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.totalDays}
                  </span>
                </Typography>
              </Stack>
            </Grid>

            {/* Right Column */}
            <Grid item xs={12} sm={6}>
              <Stack spacing={2}>
                <Typography variant="h6">
                  <strong>Reason:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.reason}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Manager Approval:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.teamApproval == "approved"
                      ? "Approved"
                      : employeeData?.teamApproval == "rejected"
                      ? "Rejected"
                      : employeeData?.teamApproval}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>HR Approval:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.hrApproval == "approved"
                      ? "Approved"
                      : employeeData?.hrApproval == "rejected"
                      ? "Rejected"
                      : employeeData?.hrApproval}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Status:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.status == "approved"
                      ? "Approved"
                      : employeeData?.status == "rejected"
                      ? "Rejected"
                      : employeeData?.status}
                  </span>
                </Typography>
              </Stack>
            </Grid>
          </Grid>

          {/* Buttons */}
          <Grid container spacing={2} justifyContent="center" marginTop={4}>
            {(employeeData?.approvalStatus?.approver?.id == locatdatas?.id ||
              display) && (
              <>
                <Grid item>
                  <MaterialButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleAddLeave("approved")}
                  >
                    Approve
                  </MaterialButton>
                </Grid>
                <Grid item>
                  <MaterialButton
                    variant="contained"
                    color="secondary"
                    onClick={() => handleAddLeave("rejected")}
                  >
                    Reject
                  </MaterialButton>
                </Grid>
              </>
            )}
            <Grid item>
              <MaterialButton
                variant="contained"
                color="dark"
                onClick={() => handleclose()}
              >
                Close
              </MaterialButton>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}

export default WFHApproval;
